import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCustomers } from 'app/entities/customer/customer.reducer';
import { getEntities as getEmployees } from 'app/entities/employee/employee.reducer';
import { RelationReportMethod } from 'app/shared/model/enumerations/relation-report-method.model';
import { RelationIncidentMethod } from 'app/shared/model/enumerations/relation-incident-method.model';
import { RelationStatusMethod } from 'app/shared/model/enumerations/relation-status-method.model';
import { createEntity, getEntity, reset, updateEntity } from './relation-customer.reducer';

export const RelationCustomerUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const customers = useAppSelector(state => state.customer.entities);
  const employees = useAppSelector(state => state.employee.entities);
  const relationCustomerEntity = useAppSelector(state => state.relationCustomer.entity);
  const loading = useAppSelector(state => state.relationCustomer.loading);
  const updating = useAppSelector(state => state.relationCustomer.updating);
  const updateSuccess = useAppSelector(state => state.relationCustomer.updateSuccess);
  const relationReportMethodValues = Object.keys(RelationReportMethod);
  const relationIncidentMethodValues = Object.keys(RelationIncidentMethod);
  const relationStatusMethodValues = Object.keys(RelationStatusMethod);

  const handleClose = () => {
    navigate('/relation-customer');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCustomers({}));
    dispatch(getEmployees({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.contactRmsId !== undefined && typeof values.contactRmsId !== 'number') {
      values.contactRmsId = Number(values.contactRmsId);
    }

    const entity = {
      ...relationCustomerEntity,
      ...values,
      customer: customers.find(it => it.id.toString() === values.customer?.toString()),
      owner: employees.find(it => it.id.toString() === values.owner?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          reportType: 'INCIDENT',
          incidentType: 'LOW',
          status: 'OPEN',
          ...relationCustomerEntity,
          customer: relationCustomerEntity?.customer?.id,
          owner: relationCustomerEntity?.owner?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.relationCustomer.home.createOrEditLabel"
            data-cy="RelationCustomerCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.relationCustomer.home.createOrEditLabel">
              Create or edit a RelationCustomer
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="relation-customer-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.type')}
                id="relation-customer-type"
                name="type"
                data-cy="type"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.title')}
                id="relation-customer-title"
                name="title"
                data-cy="title"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.reportType')}
                id="relation-customer-reportType"
                name="reportType"
                data-cy="reportType"
                type="select"
              >
                {relationReportMethodValues.map(relationReportMethod => (
                  <option value={relationReportMethod} key={relationReportMethod}>
                    {translate(`crawlerBackendApp.RelationReportMethod.${relationReportMethod}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.incidentType')}
                id="relation-customer-incidentType"
                name="incidentType"
                data-cy="incidentType"
                type="select"
              >
                {relationIncidentMethodValues.map(relationIncidentMethod => (
                  <option value={relationIncidentMethod} key={relationIncidentMethod}>
                    {translate(`crawlerBackendApp.RelationIncidentMethod.${relationIncidentMethod}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.channel')}
                id="relation-customer-channel"
                name="channel"
                data-cy="channel"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.status')}
                id="relation-customer-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {relationStatusMethodValues.map(relationStatusMethod => (
                  <option value={relationStatusMethod} key={relationStatusMethod}>
                    {translate(`crawlerBackendApp.RelationStatusMethod.${relationStatusMethod}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.description')}
                id="relation-customer-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.updateDate')}
                id="relation-customer-updateDate"
                name="updateDate"
                data-cy="updateDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.createDate')}
                id="relation-customer-createDate"
                name="createDate"
                data-cy="createDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.relationCustomer.contactRmsId')}
                id="relation-customer-contactRmsId"
                name="contactRmsId"
                data-cy="contactRmsId"
                type="text"
              />
              <ValidatedField
                id="relation-customer-customer"
                name="customer"
                data-cy="customer"
                label={translate('crawlerBackendApp.relationCustomer.customer')}
                type="select"
              >
                <option value="" key="0" />
                {customers
                  ? customers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="relation-customer-owner"
                name="owner"
                data-cy="owner"
                label={translate('crawlerBackendApp.relationCustomer.owner')}
                type="select"
              >
                <option value="" key="0" />
                {employees
                  ? employees.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/relation-customer"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RelationCustomerUpdate;
